// extracted by mini-css-extract-plugin
export default {"adminDashboard":"admin-dashboard_adminDashboard__RKhc5","menu":"admin-dashboard_menu__a6iS7","dashboardContent":"admin-dashboard_dashboardContent__q-YUX"};